import React from 'react'
import ReactDOM from 'react-dom/client'
import { HelmetProvider } from 'react-helmet-async'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
  },
})

class RootErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontFamily: 'system-ui, sans-serif',
          background: '#fff',
        }}>
          <div style={{ textAlign: 'center', maxWidth: 400, padding: '0 24px' }}>
            <h1 style={{ fontSize: 24, fontWeight: 700, color: '#111', marginBottom: 8 }}>DomBase</h1>
            <p style={{ color: '#6b7280', marginBottom: 24 }}>
              Something went wrong loading the app. This is usually a temporary issue.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#111',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '10px 24px',
                fontSize: 14,
                fontWeight: 500,
                cursor: 'pointer',
              }}
            >
              Refresh page
            </button>
            {import.meta.env.DEV && (
              <pre style={{ marginTop: 24, fontSize: 12, color: '#ef4444', textAlign: 'left', background: '#fef2f2', padding: 12, borderRadius: 6 }}>
                {(this.state.error as Error).message}
              </pre>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </QueryClientProvider>
    </RootErrorBoundary>
  </React.StrictMode>,
)
